export default __webpack_public_path__ + "static/media/chlorine.a3b6298d.png";